/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ChannelIconSVG,timeFromStatisticsFormat } from 'cx-ui-components';
import { camelCaseToRegularForm } from 'serenova-js-utils/strings';
import CheckboxFilterMenu from '../../../containers/CheckboxFilterMenu';
import { generateUUID } from 'serenova-js-utils/uuid';


const StyledChannelWrapper = styled.div`
  display: inline-block;
  cursor: auto;
  &:not(:last-child) {
    margin-right: 6px;
  }
`;

const FilterMenu = styled(CheckboxFilterMenu)`
  & .DropDown-SubMenu {
    width: 200px;
  }
`;

export const helperFunctions = {
  //channelTypesFilter: (onChange, tableType, allActive) => channelTypesFilter(onChange, tableType, allActive),
  filterMethod: ({ value = 'All' }, { agentName, presencesWrapUp }, filterValues, allActive) =>
    value === 'All'
      ? allActive
      : Object.keys(presencesWrapUp)
          .reduce(
            (prev, curr) =>
            presencesWrapUp[curr].display
                ? [...prev, curr === 'sms' ? curr.toUpperCase() : camelCaseToRegularForm(curr)]
                : prev,
            []
          )
          .filter(value => filterValues.map(({ name }) => name).includes(value)).length > 0
};

export default function presencesWrapUpColumn(presencesWrapUp, tableType, filterValues, allActive) {
  const presencesWrapUpColumn = {
    Header: 'Time in Wrap-Up',
    show: presencesWrapUp,
    id: 'presencesWrapUp',
    minWidth: 140,
    resizable: false,
    sortable: false,
    accessor: 'presencesWrapUp',
    style:{overflowX:"auto",padding:"0px"},
    filterable: false,
    //filterMethod: (filter, row) => helperFunctions.filterMethod(filter, row, filterValues, allActive),
   // Filter: ({ onChange }) => helperFunctions.channelTypesFilter(onChange, tableType, allActive),
    Cell: ({ value }) => (
      <div style={{ textAlign: 'center',display: "flex",
      flexDirection: "row" }}>
        {Object.keys(value).reduce(
          (acc, item, index) =>
          Object.keys( value[item]).length>0
              ? (function() {
                return Object.entries(value[item].minuteChannels).map(([channel,arr],indx)=>
                          { 
                            
                            return arr.length>0 ?arr.map(item=>
                              <StyledChannelWrapper key={generateUUID()} style={{
                                display: "flex",
                                flexDirection: "row",
                                textAlign: "center",
                                justifyContent: "center",
                                alignItems: "center"
                              }}>
                                <ChannelIconSVG
                               //   channelIconType={ Object.keys( value[item]).length>0 ? 'in-focus' : 'secondary'}
                                  channelType={channel}
                                  size={25}
                                  animated
                                />
                                <p>{timeFromStatisticsFormat(item.duration)}</p>
                              </StyledChannelWrapper>
                            ):<p></p>
                          
                          
                          
              }
                
                
                )})()
              : acc,
          []
        )}
      </div>
    )
  };

  presencesWrapUpColumn.Cell.propTypes = { value: PropTypes.any };

  return presencesWrapUpColumn;
}

export function channelTypesFilter(onChange, tableType, allActive) {
  return (
    <FilterMenu
      menuType="presenceWrapUpType"
      tableType={tableType}
      buttonType="columnFilter"
      selectionType="checkbox"
      updateFilter={onChange}
      hasActiveFilter={!allActive}
    >
      Time in Presence wrap up
    </FilterMenu>
  );
}
